import { Box, Typography, Paper } from "@mui/material";
import { QUESTION_TYPES, QUESTION_CATEGORIES } from "../../enums/QuestionTypes";

const QuestionTypeSidebar = ({ onDragStart, onDragEnd, onAddQuestion }) => {
    const categoryOrder = ['headers', 'questions', 'numeric', 'files', 'consent', 'other'];

    const handleDragStart = (e, typeKey) => {
        e.dataTransfer.setData("questionType", typeKey);
        e.dataTransfer.effectAllowed = "copy";

        // Set a drag image
        const dragElement = e.currentTarget;
        if (dragElement) {
            e.dataTransfer.setDragImage(dragElement, 50, 20);
        }

        if (onDragStart) onDragStart(typeKey);
    };

    const handleDragEnd = () => {
        if (onDragEnd) onDragEnd();
    };

    return (
        <Paper
            elevation={0}
            sx={{
                backgroundColor: "#FFFFFF",
                border: "1px solid #E2E8F0",
                borderRadius: "12px",
                padding: "16px",
                direction: "rtl"
            }}
        >
            <Typography
                sx={{
                    fontWeight: 600,
                    fontSize: "16px",
                    color: "#1E293B",
                    marginBottom: "16px",
                    paddingBottom: "12px",
                    borderBottom: "1px solid #E2E8F0",
                    fontFamily: '"Heebo", "Roboto", sans-serif'
                }}
            >
                רכיבים
            </Typography>

            {categoryOrder.map(categoryKey => {
                const category = QUESTION_CATEGORIES[categoryKey];
                if (!category) return null;

                return (
                    <Box key={categoryKey} sx={{ marginBottom: "16px" }}>
                        <Typography
                            sx={{
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#64748B",
                                marginBottom: "8px",
                                fontFamily: '"Heebo", "Roboto", sans-serif'
                            }}
                        >
                            {category.label}
                        </Typography>

                        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                            {category.types.map(typeKey => {
                                const questionType = QUESTION_TYPES[typeKey];
                                if (!questionType) return null;
                                const IconComponent = questionType.icon;

                                return (
                                    <Box
                                        key={typeKey}
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, typeKey)}
                                        onDragEnd={handleDragEnd}
                                        onClick={() => onAddQuestion && onAddQuestion(typeKey)}
                                        sx={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                            gap: "12px",
                                            padding: "12px",
                                            backgroundColor: "#FFFFFF",
                                            border: "1px solid #E2E8F0",
                                            borderRadius: "8px",
                                            cursor: "grab",
                                            transition: "all 0.2s ease",
                                            "&:hover": {
                                                backgroundColor: "#F8FAFC",
                                                borderColor: "#57837E",
                                                "& .icon-container": {
                                                    backgroundColor: "rgba(87, 131, 126, 0.15)"
                                                }
                                            },
                                            "&:active": {
                                                cursor: "grabbing"
                                            }
                                        }}
                                    >
                                        <Box
                                            className="icon-container"
                                            sx={{
                                                width: "32px",
                                                height: "32px",
                                                borderRadius: "8px",
                                                backgroundColor: "rgba(87, 131, 126, 0.1)",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexShrink: 0,
                                                transition: "background-color 0.2s ease"
                                            }}
                                        >
                                            <IconComponent
                                                sx={{
                                                    fontSize: "18px",
                                                    color: "#57837E"
                                                }}
                                            />
                                        </Box>
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 600,
                                                    fontSize: "13px",
                                                    color: "#1E293B",
                                                    marginBottom: "2px",
                                                    fontFamily: '"Heebo", "Roboto", sans-serif'
                                                }}
                                            >
                                                {questionType.label}
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    fontSize: "11px",
                                                    color: "#64748B",
                                                    fontFamily: '"Heebo", "Roboto", sans-serif'
                                                }}
                                            >
                                                {questionType.description}
                                            </Typography>
                                        </Box>
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>
                );
            })}
        </Paper>
    );
};

export default QuestionTypeSidebar;
